export default __webpack_public_path__ + "static/media/3.e2d9066e.webp";